import mock from './mock';
import api from './server';
import { getEnv } from '../environment';

const useMockService =
  (getEnv('NODE_ENV') === 'jest' || getEnv('NODE_ENV') === 'development') && !getEnv('VUE_APP_USE_DEV_PROXY');

const apiClient = useMockService ? mock : api;

export default apiClient;
